import { useEffect, useState } from "react";
import { Menu, Search, ShoppingCart, X, ChevronDown, ArrowRight, Home, Percent, Grid, Box, Info } from "lucide-react";
import { Link, useNavigate } from 'react-router-dom';
import { motion, AnimatePresence } from 'framer-motion';
import api from "../../api/axios"; // Adjust path to your axios.js



export default function Header(props) {
    const [isMenuOpen, setIsMenuOpen] = useState(false);
    const [isSearchOpen, setIsSearchOpen] = useState(false);
    const [searchQuery, setSearchQuery] = useState("");
    const navigate = useNavigate();
    const [cartCount, setCartCount] = useState(0);


    const [categories, setCategories] = useState([]);
    const [openCategoryId, setOpenCategoryId] = useState(null); // Tracks which menu is open

    useEffect(() => {
        api.get("/categories")
            .then((res) => {
                // res.data.data now contains { id, name, slug, children: [...] }
                setCategories(res.data.data);
            })
            .catch((err) => console.error(err));
    }, []);

    // Toggle function for the accordion
    const toggleCategory = (id) => {
        setOpenCategoryId(openCategoryId === id ? null : id);
    };



    const getCartCount = () => {
        const cart = localStorage.getItem("my_cart");
        if (!cart) return 0;
        return JSON.parse(cart).length;
    };




    useEffect(() => {
        // Initial load
        setCartCount(getCartCount());

        // Listen to cart updates (same tab)
        const handleCartUpdate = () => {
            setCartCount(getCartCount());
        };

        window.addEventListener("cartUpdated", handleCartUpdate);
        window.addEventListener("storage", handleCartUpdate); // other tabs

        return () => {
            window.removeEventListener("cartUpdated", handleCartUpdate);
            window.removeEventListener("storage", handleCartUpdate);
        };
    }, []);





    // Navigation Logic
    const scrollTo2 = (id) => {
        setTimeout(() => {
            document.getElementById(id)?.scrollIntoView({ behavior: "smooth" });
        }, 500);
    };

    const scrollTo = (id) => {
        setIsMenuOpen(false); // Auto-close sidebar on click
        if (props.target === "home") {
            document.getElementById(id)?.scrollIntoView({ behavior: "smooth" });
        } else {
            navigate("/");
            scrollTo2(id);
        }
    };

    const handleSearch = (e) => {
        if (e) e.preventDefault();
        if (searchQuery.trim()) {
            navigate(`/search/${searchQuery.trim()}`);
            setIsSearchOpen(false);
            setSearchQuery("");
        }
    };

    return (
        <>
            {/* HEADER */}
            <header id="header" className="sticky top-0 w-full bg-white border-b border-gray-100 flex items-center p-4 md:px-8 z-40 h-[auto] md:h-[auto]">
                {/* LEFT - MENU */}
                <div className="flex-1 flex items-center">
                    <button onClick={() => setIsMenuOpen(true)} className="p-2 hover:bg-gray-50 rounded-full transition-colors">
                        <Menu aria-label="Menu" color="black" size={26} />
                    </button>
                </div>

                {/* CENTER - LOGO */}
                <div className="flex-1 flex justify-center">
                    <Link onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })} to={"/"}>
                        <img src="/assets/images/logo.png" alt="Electro Titane" className="w-[9rem] md:w-[180px] object-contain" />
                    </Link>
                </div>

                {/* RIGHT - SEARCH + CART */}
                <div className="flex-1 flex justify-end items-center gap-2 md:gap-4">
                    <button onClick={() => setIsSearchOpen(true)} className="p-2 hover:bg-gray-50 rounded-full transition-colors">
                        <Search aria-label="search" color="black" size={24} />
                    </button>
                    <Link to={"/cart"} className="p-2 hover:bg-gray-50 rounded-full transition-colors relative">
                        <ShoppingCart aria-label="cart" color="black" size={24} />
                        {/* FIX: Use cartCount state instead of hardcoded 2 */}
                        {cartCount > 0 && (
                            <span className="absolute top-1 right-1 bg-[#FFAA00] text-white text-[10px] font-bold w-4 h-4 flex items-center justify-center rounded-full">
                                {cartCount}
                            </span>
                        )}
                    </Link>
                </div>

                {/* SEARCH OVERLAY */}
                <AnimatePresence>
                    {isSearchOpen && (
                        <motion.div initial={{ opacity: 0, y: -20 }} animate={{ opacity: 1, y: 0 }} exit={{ opacity: 0, y: -20 }} className="absolute inset-0 bg-white z-[50] flex items-center px-4 md:px-8 gap-4">
                            <form onSubmit={handleSearch} className="flex-1 flex items-center relative">
                                <Search size={20} className="absolute left-4 text-gray-400" />
                                <input autoFocus type="text" value={searchQuery} onChange={(e) => setSearchQuery(e.target.value)} placeholder="Rechercher..." className="w-full h-12 pl-12 pr-12 bg-gray-50 border-none rounded-2xl focus:ring-2 focus:ring-[#FFAA00] outline-none font-medium" />
                                {searchQuery && (
                                    <button type="submit" className="absolute right-3 p-1.5 bg-[#FFAA00] text-white rounded-xl hover:scale-105 transition-transform">
                                        <ArrowRight size={18} />
                                    </button>
                                )}
                            </form>
                            <button onClick={() => setIsSearchOpen(false)} className="p-3 hover:bg-gray-100 rounded-full text-gray-500 transition-colors">
                                <X size={26} />
                            </button>
                        </motion.div>
                    )}
                </AnimatePresence>
            </header>

            {/* SIDEBAR MENU */}
            <div className={`fixed top-0 left-0 w-72 h-full bg-white shadow-2xl transform transition-transform duration-500 cubic-bezier(0.4, 0, 0.2, 1) z-50 ${isMenuOpen ? "translate-x-0" : "-translate-x-full"}`}>
                <div className="flex justify-between items-center p-6 border-b">
                    <span className="text-xs font-black uppercase tracking-[0.2em] text-[#8A8A89]">Electro Titan</span>
                    <button aria-label="Close menu" onClick={() => setIsMenuOpen(false)} className="p-1 hover:rotate-90 transition-transform">
                        <X color="black" size={24} />
                    </button>
                </div>

                <nav className="flex flex-col p-4 gap-1 overflow-y-auto h-[calc(100vh-80px)] custom-scrollbar">
                    {/* CATEGORIES SECTION */}
                    <div className="mb-6">
                        <p className="px-4 mb-2 text-[10px] font-black uppercase tracking-widest text-[#8A8A89]">Categories</p>


                        {categories.map((cat) => (
                            <div key={cat.id} className="flex flex-col">
                                {/* PARENT ROW */}
                                <div
                                    className="flex justify-between items-center cursor-pointer px-4 py-3 hover:bg-gray-50 rounded-xl transition-colors"
                                    onClick={() => cat.children.length > 0 ? toggleCategory(cat.id) : setIsMenuOpen(false)}
                                >
                                    <div
                                        className="font-bold text-gray-800 text-sm flex-grow"
                                    >
                                        {cat.name}
                                    </div>

                                    {cat.children.length > 0 && (
                                        <ChevronDown
                                            size={14}
                                            className={`text-gray-400 transition-transform duration-300 ${openCategoryId === cat.id ? "rotate-180" : ""}`}
                                        />
                                    )}
                                </div>

                                {/* CHILDREN DROPDOWN */}
                                <AnimatePresence>
                                    {openCategoryId === cat.id && cat.children.length > 0 && (
                                        <motion.div
                                            initial={{ height: 0, opacity: 0 }}
                                            animate={{ height: "auto", opacity: 1 }}
                                            exit={{ height: 0, opacity: 0 }}
                                            className="ml-6 flex flex-col space-y-1 border-l-2 border-gray-100 overflow-hidden"
                                        >
                                            {cat.children.map((sub) => (
                                                <Link
                                                    key={sub.id}
                                                    to={`/categorie/${cat.slug}/${sub.slug}`}
                                                    className="p-2 text-xs font-bold rounded-lg pl-6 text-gray-400 hover:text-[#ffaa00] transition-colors"
                                                    onClick={() => setIsMenuOpen(false)}
                                                >
                                                    {sub.name}
                                                </Link>
                                            ))}
                                        </motion.div>
                                    )}
                                </AnimatePresence>
                            </div>
                        ))}


                    </div>

                    {/* QUICK NAVIGATION SECTION */}
                    <div className="pt-6 border-t border-gray-100">
                        <p className="px-4 mb-4 text-[10px] font-black uppercase tracking-widest text-[#8A8A89]">Navigation Rapide</p>
                        <ul className="flex flex-col gap-1">
                            <li onClick={() => scrollTo("header")} className="flex items-center gap-3 px-4 py-3 font-bold text-sm text-gray-800 cursor-pointer hover:bg-gray-50 hover:text-[#FFAA00] rounded-xl transition-all">
                                <Home size={18} /> Accueil
                            </li>
                            <li onClick={() => scrollTo("promos")} className="flex items-center gap-3 px-4 py-3 font-bold text-sm text-gray-800 cursor-pointer hover:bg-gray-50 hover:text-[#FFAA00] rounded-xl transition-all">
                                <Percent size={18} /> Nos Promos
                            </li>
                            <li onClick={() => scrollTo("category")} className="flex items-center gap-3 px-4 py-3 font-bold text-sm text-gray-800 cursor-pointer hover:bg-gray-50 hover:text-[#FFAA00] rounded-xl transition-all">
                                <Grid size={18} /> Nos Catégories
                            </li>
                            <li onClick={() => scrollTo("nos-produits")} className="flex items-center gap-3 px-4 py-3 font-bold text-sm text-gray-800 cursor-pointer hover:bg-gray-50 hover:text-[#FFAA00] rounded-xl transition-all">
                                <Box size={18} /> Nos Produits
                            </li>
                            <li onClick={() => scrollTo("about")} className="flex items-center gap-3 px-4 py-3 font-bold text-sm text-gray-800 cursor-pointer hover:bg-gray-50 hover:text-[#FFAA00] rounded-xl transition-all">
                                <Info size={18} /> À Propos
                            </li>
                        </ul>
                    </div>
                </nav>
            </div>

            {/* OVERLAY */}
            {(isMenuOpen || isSearchOpen) && (
                <motion.div initial={{ opacity: 0 }} animate={{ opacity: 1 }} className="fixed inset-0 bg-black/40 backdrop-blur-sm z-30" onClick={() => { setIsMenuOpen(false); setIsSearchOpen(false); }} />
            )}
        </>
    );
}